// extracted by mini-css-extract-plugin
export default {"polaroidContainer":"Polaroid-module--polaroidContainer--1gmiG","cardHeader":"Polaroid-module--cardHeader--IFCpt","subHeader":"Polaroid-module--subHeader--2vW0w"};